var $sexToSelect = $('input:radio[name="properties[Sex]"]');

//Variabili per emissionii
var pesoProdotto = 500;


$( document ).ready(function() {
  //MODALS
  var modal = $('[data-modal=modal]').remodal();
    
  
  $(document).on('opened', '[data-modal=modal]', function () {
    enableTooltips();
  });
  
  $('.ShopifyFakeProperty').change(function () {
    var $radios = $('input[name="'+ $(this).attr('data-update') +'"]');
    $radios.filter('[value='+ $(this).val() +']').prop('checked', true);
  });
  
  
  if (productJson.tags.includes("selectLady")) {
    $sexToSelect.filter('[value=Female]').attr('checked', true);
  }
  
  
});





/* DISPONIBILITA' KG  nel caso Airtable */

var availabilityFabrics = {};
var plantIndexFabrics = {}
var forceShippingDate = {}
var customWashing = {}
var customWashingDesc = {}
var models = []

//Product_material definito nel product json
var product_consumo = 1;
var produzioneSeDisponibile = 10; //Giorni per produrre il prodotto, lo prendo da AirTable
var soloOpzioneColore = 0;
var checkInseam = false;
var trovatoColore = false;
var fornitoreProdotto = 'Feng'

for (i = 0; i < productJson.options.length; i++) {
  if(productJson.options[i].toLowerCase().includes('inseam') || productJson.options[i].toLowerCase().includes('gamb')) {
    checkInseam = true;
  }

  // Array contenente i termini per "colore" nelle lingue specificate
  const coloriTermini = [
    'color',       // inglese
    'couleur',     // francese
    'color',       // spagnolo
    'colore',      // italiano
    'لون',         // arabo
    '颜色',         // cinese semplificato
    'Farbe'        // tedesco
  ];

  // Controlla se la stringa contiene uno dei termini per "colore"
  if(coloriTermini.some(term => productJson.options[i].toLowerCase().includes(term)) && i == 0) {
    soloOpzioneColore = 1;
  }

  if(coloriTermini.some(term => productJson.options[i].toLowerCase().includes(term))) {
    trovatoColore = true;
  }
} 

if (product_materiale_tipo == 'Filato' ) {
  produzioneSeDisponibile = 8;
  produzioneSeFinito = 30;  
} else{
  produzioneSeDisponibile = 12;
  produzioneSeFinito = 120;  
}


var variantSet;
var current_variant_colorSet;
var sectionIdSet;
var thisProductOption = productJson;

function updateDoorstepStage(stage) {
  //Ci possono essere tre stage:
  //  -FABRIC: occorre produrre il tessuto/filato
  //  -MANUFACTURE: c'è il tessuto/filato ma occorre produrre il PRODOTTO
  // - DELIVERY: c'è il prodotto, occorre solo spedire
  
  $( document ).ready(function() {
    switch(stage) {
      case "FABRIC":
      //Set tooltips
      $("#doorstep_fabric_desc2").text(window.operacampithemeStrings.DoorStepProduce);
      $("#doorstep_manufacture_desc2").text(window.operacampithemeStrings.DoorStepSew);
      $("#doorstep_delivery_desc2").text(window.operacampithemeStrings.DoorStepDelivery);
      
      //Tolgo qualsiasi active
      $("#doorstep_fabric").removeClass("active");
      $("#doorstep_fabricToManufacture").removeClass("active");
      $("#doorstep_manufacture").removeClass("active");
      $("#doorstep_manufactureToDelivery").removeClass("active");
      break;
      case "MANUFACTURE":
      //Set tooltips
      $("#doorstep_fabric_desc2").text(window.operacampithemeStrings.DoorStepFabricLab);
      $("#doorstep_manufacture_desc2").text(window.operacampithemeStrings.DoorStepFabricManuf);
      $("#doorstep_delivery_desc2").text(window.operacampithemeStrings.DoorStepFabricDelivery);
      
      //Tolgo qualsiasi active
      $("#doorstep_fabric").addClass("active");
      $("#doorstep_fabricToManufacture").addClass("active");
      $("#doorstep_manufacture").removeClass("active");
      $("#doorstep_manufactureToDelivery").removeClass("active");
      
      break;
      case "DELIVERY":
      //Set tooltips
      $("#doorstep_fabric_desc2").text(window.operacampithemeStrings.DoorStepFabricTooltip);
      $("#doorstep_manufacture_desc2").text(window.operacampithemeStrings.DoorStepFabricManufTooltip);
      $("#doorstep_delivery_desc2").text(window.operacampithemeStrings.DoorStepFabricDeliveryTooltip);
      
      //Tolgo qualsiasi active
      $("#doorstep_fabric").addClass("active");
      $("#doorstep_fabricToManufacture").addClass("active");
      $("#doorstep_manufacture").addClass("active");
      $("#doorstep_manufactureToDelivery").addClass("active");
      break;
      
      
    }
    
  }); 
  
}


function setSoldout() {
  $(".AddToCartButton").prop('disabled', true);
  $(".AddToCartText").text(theme.strings.soldOut);
  
  $('#product_label_soldout').show();
  $('.product_shipping').html("Not available");
  $('#product_label_available').hide();
  $("#soldOutSubscribeSnippet").show();
  $("#detailed_product_shipping_info").hide();
  $(".mandatory_date").hide();
  $("#preorder_date").hide();
  
}

function setAvailable() {
  $(".AddToCartButton").prop('disabled', false);
  $(".AddToCartText").text(theme.strings.addToCart);
  
  $('#product_label_available').show();
  $('#product_label_soldout').hide();
  $("#soldOutSubscribeSnippet").hide();
  $("#detailed_product_shipping_info").show();
  $(".mandatory_date").show();
}

function updateEstimateDelivery(estimate_days) {
  var now = moment();
  
  //Se c'è metafield force shipping date forzo il numero di giorni
  if (force_shipping_date !== '') {
    force_shipping_date = moment(force_shipping_date,"YYYY-MM-DD");
    if (force_shipping_date > now) {
      let start = now; //Pick any format
      let end = force_shipping_date; //right now (or define an end date yourself)
      let weekdayCounter = 0;  
      while (start <= end) {
        if (start.format('ddd') !== 'Sat' && start.format('ddd') !== 'Sun'){
          weekdayCounter++; //add 1 to your counter if its not a weekend day
        }
        start = moment(start, 'YYYY-MM-DD').add(1, 'days'); //increment by one day
      }
      estimate_days = weekdayCounter;
    }
  } 
  //NATALE O ALTRI PERIODI FESTIVI, ESTENDO I GIORNI
  if (now.isAfter(now.year()+'-12-14', 'day') && now.isBefore(now.year()+'-12-28', 'day') && estimate_days != 3) {
    estimate_days = estimate_days + 6;
  }

  //SE FATTO SU MISURA CHIEDO DUE GIORNI IN PIU'
  if ($(".sizeSwatchGroup").length && $('.sizeSwatchGroup input[type=radio]:checked').val().toUpperCase().includes('MEASURE')) {
    estimate_days = estimate_days + 2;
  }
   

  //CALCOLO GIORNI
  
  //Update pre order se giorni per ricevere è superiore o uguale a 12 giorni
  if (estimate_days >= 22 ) {
    $("#preorder_date").show();
  } else {
    $("#preorder_date").hide();
  }  


    //Periodo di tanti ordini o di vacanze: se è consegna meno di 6 giorni decorre dal giorno di ritorno. Altrimenti decorre da 6 giorni prima del ritorno.
    //  var giornoRitorno = moment('03/05/2025',"DD/MM/YYYY"); //Cambiare giorno ritorno
    //  var giornoPartenza = moment('16/04/2025',"DD/MM/YYYY"); //Giorno da quando è difficile produrre
    //  var giornoInizioProduzione = giornoRitorno;
    //  if (now.isBefore(giornoRitorno) ) { 
    //    if(estimate_days <= 6 && now.isAfter(giornoPartenza)) {
    //     giornoInizioProduzione = giornoRitorno.add(-10, 'days');
    //   } else if (!now.isAfter(giornoPartenza) && estimate_days <= 6) {
    //     giornoInizioProduzione = now;
    //   } else {
    //       giornoInizioProduzione = giornoRitorno.add(-8, 'days');
    //    } 
 
    //    let start = moment(); //Pick any format
    //    let end = giornoInizioProduzione; //right now (or define an end date yourself)
    //    let weekdayCounter = 0;  
    //    while (start <= end) {
    //      if (start.format('ddd') !== 'Sat' && start.format('ddd') !== 'Sun'){
    //        weekdayCounter++; //add 1 to your counter if its not a weekend day
    //      }
    //      start = moment(start, 'YYYY-MM-DD').add(1, 'days'); //increment by one day
    //    }
    //    estimate_days = estimate_days + weekdayCounter;      
    //  }
  
  
    //Aggiungo giorni gestione ordine (deciso con Fabri febbraio 2023)
    var estimateDelivery = addWeekdays(now, estimate_days).locale(currentLanguage).format("D MMMM YYYY");  
    if (estimate_days != 3 && force_shipping_date == '' && now.isBefore(now.year()+'-12-04', 'day') ) { //escluso periodi festivi
      estimateDelivery = addWeekdays(now, estimate_days-3).locale(currentLanguage).format("D MMMM YYYY") +  " - " + addWeekdays(now, estimate_days).locale(currentLanguage).format("D MMMM YYYY");
    } 


    
  //NATALE: CONSEGNA ENTRO IL 20 dicembre
  //fino all'11 dicembre i prodotti in maglieria mette fissa data di consegna 20 dicembre se va oltre natale
   if (now.isAfter(now.year()+'-12-01', 'day') && now.isBefore(now.year()+'-12-14', 'day') 
    && addWeekdays(now, estimate_days).isAfter(now.year()+'-12-20', 'day') 
    && estimate_days <= 25 && estimate_days != 3
    && product_materiale_tipo == 'Filato'   
   ) {
     //calcolo i giorni dalla di spedizione ad oggi
     estimateDelivery = moment("20/12/"+now.year(),"DD/MM/YYYY").locale(currentLanguage).format("D MMMM YYYY");
     let start = moment(); //Pick any formcat
     let end = moment("20/12/"+now.year(),"DD/MM/YYYY"); //right now (or define an end date yourself)
     let weekdayCounter = 0;   
  
     while (start <= end) {
       if (start.format('ddd') !== 'Sat' && start.format('ddd') !== 'Sun'){
         weekdayCounter++; //add 1 to your counter if its not a weekend day
       }
       start = moment(start, 'YYYY-MM-DD').add(1, 'days'); //increment by one day
     }
     estimate_days = weekdayCounter;
     $("#preorder_date").show();
     $("#preorder_date").addClass('inTimeForChristmas');
     $("#preorder_date").html(window.operacampithemeStrings.InTimeForChristmas);
   }

  if (addWeekdays(now, estimate_days).isBefore(now.year()+'-12-25', 'day') && now.isBefore(now.year()+'-12-20', 'day') && now.isAfter(now.year()+'-12-01', 'day'))
  {
    if (estimate_days <= 5)
    {
      estimate_days = 2;
    }
    $("#preorder_date").show();
    $("#preorder_date").addClass('inTimeForChristmas');
    $("#preorder_date").html(window.operacampithemeStrings.InTimeForChristmas);
  }

  
  

  //Aggiorno data visualizzata e programmazione
  $('.product_shipping').html(estimateDelivery);
  $("#DeliveryProperty").val(estimate_days);
}

function updateProductShipping(variant,current_variant_color,sectionId) {
  variantSet = variant;
  current_variant_colorSet = current_variant_color;
  sectionIdSet = sectionId;
  var objectProp;
  if (current_variant_color === null) {
    objectProp = product_materiale;
  } else {
    objectProp = product_materiale + current_variant_color.replace(/\s/g,'').toLowerCase();
  }

  var now = moment();
  var currentAvailableQuantity = variant.inventory_quantity;

  var quickDeliveryAvailable = false;
// quick delivery solo se è un prodotto da donna, da uomo oppure unisex ma ho selezionato uomo oppure se non è maglieria
if (
  product_materiale_tipo !== 'Filato' ||
  (product_sex == 'man' || product_sex == 'lady' ||  
   $('input[type=radio][name="properties[Sex]"]:checked').val()?.replaceAll(" ", "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() == 'male')
) {
  quickDeliveryAvailable = true;
}
  
  if ($("#Quantity")) {
    $("#Quantity").prop('max',currentAvailableQuantity);
  }
  
  if (currentAvailableQuantity < 0) {
    currentAvailableQuantity = 0;
  }
  
  //approfitto per aggiornare plantindex su colore e tessuto
  if (plantIndexFabrics[objectProp]) {
    $(".plant_index_vote").html(plantIndexFabrics[objectProp]);
  }
 
  var actualForceShipping = force_shipping_date;
  if (forceShippingDate[objectProp]) {
    force_shipping_date = forceShippingDate[objectProp];
  } else {
    force_shipping_date = default_force_shipping_date;
  }
  
  if (customWashing[objectProp] && customWashing[objectProp] !== "") {
    $(".washingCustom").html(customWashing[objectProp]);
    $(".washingDefault").hide();
    $(".washingDesc").hide();
    $(".washingCustom").show();
    $(".washingCustomDesc").show();
  } else {
    $(".washingDefault").show();
    $(".washingDesc").show();
    $(".washingCustom").hide();
    $(".washingCustomDesc").hide();
  }
  if (customWashingDesc[objectProp] && customWashingDesc[objectProp] !== "") {
    $(".washingCustomDesc").html(customWashingDesc[objectProp]);
    $(".washingDefault").hide(); 
    $(".washingDesc").hide();
    $(".washingCustom").show();
    $(".washingCustomDesc").show();
  } else {
    $(".washingDefault").show();
    $(".washingDesc").show();
    $(".washingCustom").hide();
    $(".washingCustomDesc").hide();
  }
  
  
  //NEL CASO DI PRODOTTI CON VARIANTI CHE CONDIVIDONO LE QUANTITA' CON ALTRE
  //Prendo product variant, nel caso di pantalone con INSEAM aggiungo le quantità se è più corta
  if (checkInseam) {
    thisProductOption.variants.forEach(function(entry) {
      //La variante selezionata è Short, aggiungo eventuali regular e Tall
      if (variant.option3 == "Short") {
        if (entry.option1 == variant.option1 && entry.option2 == variant.option2 && (entry.option3 == 'Tall' || entry.option3 == 'Regular')) {
          if (entry.inventory_quantity >= 0) {
            currentAvailableQuantity = currentAvailableQuantity + entry.inventory_quantity;
          }
        }
      }
      //La variante selezionata è Regular, aggiungo eventuali Tall
      if (variant.option3 == "Regular") {
        if (entry.option1 == variant.option1 && entry.option2 == variant.option2 && entry.option3 == 'Tall') {
          if (entry.inventory_quantity >= 0) {
            currentAvailableQuantity = currentAvailableQuantity + entry.inventory_quantity;
          }
        }
      }
    });
  }
  
  
  
  if(variant.incoming) {
    updateEstimateDelivery(18);
    setAvailable();
   
  } else if (variant.available == true && currentAvailableQuantity  <= 0 && variant.inventory_policy == 'continue' && current_variant_color) {
    
    if((availabilityFabrics[objectProp] / parseFloat(product_consumo))<1 && produzioneSeFinito > 30) {
      //Non c'è più tessuto e ci vuole parecchio tempo e non c'è inventario.
      updateDoorstepStage("FABRIC");
      updateEstimateDelivery(produzioneSeFinito);
      $('.product_shipping').html(window.operacampithemeStrings.NeedFabricProduction.replace('{1}', produzioneSeFinito) );
    } else if ((availabilityFabrics[objectProp] / parseFloat(product_consumo))<1 && produzioneSeFinito <= 30) {
      //Non c'è più tessuto e ci vuole poco tempo e non c'è inventario.
      updateEstimateDelivery(produzioneSeFinito);
      updateDoorstepStage("FABRIC");
      
    } else {
      //C'è tessuto ma non c'è inventario.
      updateEstimateDelivery(produzioneSeDisponibile);
      updateDoorstepStage("MANUFACTURE");
    }
    
    setAvailable();
  } else if(variant.available == false && currentAvailableQuantity  <= 0 && variant.inventory_policy == 'deny') {
    //Non voglio più venderlo e non c'è inventario.
    setSoldout();
    updateDoorstepStage("FABRIC");
    
  } else {
    
    //Valori di default
    if (currentAvailableQuantity  <= 0) {
      //Non c'è inventario e voglio venderlo
      updateEstimateDelivery(produzioneSeDisponibile);
      setAvailable();
      updateDoorstepStage("MANUFACTURE");
      
    } else if (quickDeliveryAvailable) {
      //È disponibile!
      updateEstimateDelivery(3);
      setAvailable();
      updateDoorstepStage("DELIVERY");
    } else {
      updateEstimateDelivery(produzioneSeDisponibile);
      setAvailable();
      updateDoorstepStage("MANUFACTURE");
    }
  }

  //NATALE
  if (currentAvailableQuantity  <= 0 && now.isAfter(now.year()+'-12-16', 'day') && now.isBefore(now.year()+'-12-19', 'day')) {
    setSoldout();
  } else if (currentAvailableQuantity  > 0) {
    setAvailable(); 
  }


  
  if ($('#total_available').length){
    $('#total_available').html(currentAvailableQuantity ); //+ parseInt(availabilityFabrics[objectProp] / product_consumo)
  }
  
  
  //UPDATE SWATCH INTELLIGENTE
  var option1toCheck; //controllo se è cambiata taglia
  var option1quantity; //controllo quantità totale taglia
  var option3toCheck; //controllo se è cambiata taglia
  var option3quantity; //controllo quantità totale taglia
  
  var lunghezzaDisponibilita; //controllo disponibilità lunghezza più lunga
  
  //INIZIO FUNZIONE
  //option1: TAGLIA
  //option2: colore
  //option3: inseam/zipper
  //variant è la variante scelta, entry è la variante del for
  thisProductOption.variants.forEach(function(entry) {
    if (variant.option2 == entry.option2) { //Controllo solo se è lo stesso colore selezionato
      
      //Se sto guardando la stessa taglia sommo le quantità, se c'è una sola variante disponibile dentro la taglia, questa non è sold out!
      if (entry.option1 == option1toCheck) {
        if (entry.inventory_quantity >= 0) {
          option1quantity = option1quantity + entry.inventory_quantity;
        }
      } else {
        option1quantity = entry.inventory_quantity;
        option1toCheck = entry.option1;
      }
      
      //Check quantità option3 solo però per la stessa taglia selezionata se è inseam, invece solo per lo stesso colore se è zipper
      if(entry.option1 == variant.option1 && checkInseam) {
        if (entry.option3 == option3toCheck) {
          if (entry.inventory_quantity >= 0) {
            option3quantity = option3quantity + entry.inventory_quantity;
          }
        } else {
          option3quantity = entry.inventory_quantity;
          option3toCheck = entry.option3;
        }
      } else {
        if (entry.option3 == option3toCheck) {
          if (entry.inventory_quantity >= 0) {
            option3quantity = option3quantity + entry.inventory_quantity;
          }
        } else {
          option3quantity = entry.inventory_quantity;
          option3toCheck = entry.option3;
        }
      }
      
      //Se è disponibile metto disponibile, altrimenti sold out (taglie option1)
      if (entry.available == false && option1quantity <= 0 && entry.inventory_policy !== "continue") {
        $(".swatch-element[data-value='"+ entry.option1 +"']").addClass("soldout").removeClass("available");
      } 
      else {
        $(".swatch-element[data-value='"+ entry.option1 +"']").removeClass("soldout").addClass("available");
      }
      

      //Se c'è magazzino spedisce subito
      if ($(".swatch-element[data-value='"+ entry.option1 +"']").hasClass("quickDelivery")) {
        //Resetto classe
        $(".swatch-element[data-value='"+ entry.option1 +"']").removeClass("quickDelivery");
      }
      if ( entry.inventory_quantity > 0 && quickDeliveryAvailable) {
        $(".swatch-element[data-value='"+ entry.option1 +"']").attr("data-bs-toggle","tooltip");
        $(".swatch-element[data-value='"+ entry.option1 +"']").attr("data-bs-title",window.operacampithemeStrings.QuickDelivery);
        $(".swatch-element[data-value='"+ entry.option1 +"']").addClass("quickDelivery");
      } else {
        //NATALE
        if (now.isAfter(now.year()+'-12-16', 'day') && now.isBefore(now.year()+'-12-19', 'day')) {
          $(".swatch-element[data-value='"+ entry.option1 +"']").addClass("soldout").removeClass("available");
         }
        $(".swatch-element[data-value='"+ entry.option1 +"']").removeAttr("data-bs-toggle");
        $(".swatch-element[data-value='"+ entry.option1 +"']").removeAttr("data-bs-title");
        var tooltipObj = bootstrap.Tooltip.getInstance($(".swatch-element[data-value='"+ entry.option1 +"']"));
          if (tooltipObj) {
            tooltipObj.dispose();
          }
      }

      
      
      //Se è disponibile metto disponibile solo per lo stesso colore e stessa taglia, altrimenti sold out
      if (entry.option1 == variant.option1) {
        if (entry.available == false && option3quantity <= 0 && entry.inventory_policy !== "continue") {
          $(".swatch-element[data-value='"+ entry.option3 +"'][data-option='2']").addClass("soldout").removeClass("available");
        } else {
          $(".swatch-element[data-value='"+ entry.option3 +"'][data-option='2']").removeClass("soldout").addClass("available");
        }
      }
      
      
    }
    

  });

  //Resetto tooltips
  enableTooltips();  

  
  
  //Una volta fatto tutto, controllo gli swatch dell'option 3 perché è sempre l'inseam e se è disponibile una regular deve esserlo anche la short.
  var selects = $('body').find('.swatch_el_inseam');
  selects.each(function(index, el) {
    // se esiste il prossimo swatch inseam controllo se è disponibile quindi rendo disponibile anche questo
    if(selects.eq(index + 1).hasClass("available")) {
      selects.eq(index).removeClass("soldout").addClass("available");
    }
  });

  
} //FINE FUNZIONE PRODUCT SHIPPING

function createSpec(title,icon = "",record,tooltip ="",container = "#specs_row" ) {
  var html = "";
  var additionalClasses = "";

  if (icon == "" && record.toLowerCase().includes("piece") ) {
    record = "<span class='noColorFeature_zero'>" + window.operacampithemeStrings.Spec_PieceDyeing + "</span>";
    record += "<span class='ColorFeature_zero'>" + window.operacampithemeStrings.Spec_Undyed + "</span>";
  } else if (icon == "" && record.toLowerCase().includes("yarn")) {
    record = "<span class='noColorFeature_zero'>" + window.operacampithemeStrings.Spec_YarnDyeing + "</span>";
    record += "<span class='ColorFeature_zero'>" + window.operacampithemeStrings.Spec_Undyed + "</span>";
  }
  if (icon == "" && record.toLowerCase().includes("undye")) {
    record = "<span class='ColorFeature_zero'>" + window.operacampithemeStrings.Spec_Undyed + "</span>";
  }


  html = html + "<div class='spec feature_with_icon col-6 col-sm-4'"
  if (tooltip !== "") {
    html = html + " data-bs-toggle = 'tooltip' data-bs-title='" + tooltip.replace(/"/g, '&quot;') + "'";
  }
  html = html + "><div class='feature_icon_header'><div class='row g-0 align-items-center'>";
  if (icon !== "") { html = html + "<div class='col-4 col-sm-3'> <span class='iconNucleo feature-icon-icon icon'>"+ icon +"</span> </div>"  }
  html = html + "<div class='col-8 col-sm-9'> <div class='feature-icon-title mb-0'>"
  if (tooltip !== "") {
    html = html + "<span class='iconNucleo text-small me-2'></span>"
  }
  html = html + "<small>" + title + "</small></div><p>" + record + "</p> </div></div> </div>"
  $(container).append(html);
} 

// Funzione per convertire CSV in JSON con gestione delle virgole e virgolette
function csvToJson(csv) {
  const lines = csv.trim().split("\n");
  const headers = lines[0].split(",").map(header => header.trim());
  const result = [];

  for (let i = 1; i < lines.length; i++) {
    const obj = {};
    const values = [];
    let value = "";
    let insideQuotes = false;

    // Iteriamo sui caratteri per creare un array di valori
    for (let char of lines[i]) {
      if (char === '"' && !insideQuotes) {
        insideQuotes = true;
      } else if (char === '"' && insideQuotes) {
        insideQuotes = false;
      } else if (char === ',' && !insideQuotes) {
        values.push(value.trim());
        value = "";
      } else {
        value += char;
      }
    }
    values.push(value.trim());

    // Creiamo l'oggetto per la riga corrente
    headers.forEach((header, j) => {
      let cellValue = values[j] ? values[j].replace(/^"|"$/g, '') : null;

      // Se il valore è numerico con virgola, convertilo in punto decimale
      if (cellValue && !isNaN(cellValue.replace(',', '.'))) {
        cellValue = cellValue.replace(',', '.');
      }

      obj[header] = cellValue;
    });

    result.push(obj);
  }
  return result;
}




function updateFromAirTableMaterials() {
 // URL del foglio Google Materiali in formato CSV
const materialiUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQsxeAcUSQJ3YWF5RfcMtceLqScbJh5engVc2XjTcrT4TkapU27KEt1nSJy6BF9E9dSxPcSJjIs4rZk/pub?output=csv';

// Funzione per caricare i dati dal foglio Materiali e aggiornare le specifiche
  fetch(materialiUrl)
    .then(response => response.text())
    .then(data => {
      const jsonData = csvToJson(data);
      // Ciclo sui record del foglio Materiali
      jsonData.forEach(record => {
        if (record.Name) {
          // Aggiorna le specifiche dei tessuti
          availabilityFabrics[record.Name] = record.Quantita;
          plantIndexFabrics[record.Name] = record.PlantIndex;
          customWashing[record.Name] = record.WashingCustom;
          customWashingDesc[record.Name] = record.WashingCustomDesc;
          
          if (record.ForzaDataSpedizione) {
            forceShippingDate[record.Name] = record.ForzaDataSpedizione;
          }
        }
      });

            // Chiamate alle funzioni aggiuntive alla fine del processo
            updateProductShipping(variantSet, current_variant_colorSet, sectionIdSet);
            enableTooltips();
            updateFromAirTableProducts();

    })
    .catch(error => console.error('Errore nel caricamento dei materiali:', error));
}

// Funzione per creare le specifiche del materiale
function createMaterialSpec(materialSource) {
  if (materialSource !== undefined) {
    const icon = "";
    const title = window.operacampithemeStrings.rawMaterial;
    let tooltip = "";
    let recordToPass = materialSource;

    if (materialSource.includes("China") || materialSource.includes("Cina")) {
      tooltip = window.operacampithemeStrings.WhyChina.replace(/"/g, '&quot;');
    }

    createSpec(title, icon, recordToPass, tooltip);
  }

// Esempio di chiamata alla funzione loadMaterials
// loadMaterials();

    
    
  }
  

  function updateFromAirTableProducts() {
    //GOOGLE
// Funzione per aggiornare le specifiche del prodotto dal foglio Google Sheets
  // URL del foglio Google Sheets in formato CSV
const url = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTeh_Pt0foQG2fbcbh8VCT9t2y8sKXrTAM684J4uGczrtECFfUbfZChIRmCwI_-GeS_OK1GvWpm9m4b/pub?output=csv';

var productHandle = productJson.handle;
// Funzione principale per ottenere i dati e aggiornare le specifiche
  fetch(url)
    .then(response => response.text())
    .then(data => {
      const jsonData = csvToJson(data);
      
      // Trova il prodotto specifico usando il productHandle
      const productData = jsonData.find(entry => entry.ProductHandle === productHandle);
      
      if (productData) {
        var icon = "";
        var title;
        var get;
        var recordToPass;
        var tooltip = "";

        // Logica GiorniProduzione e Fornitore
        if (productData.GiorniProduzione && parseInt(productData.GiorniProduzione) > 0) {
          produzioneSeDisponibile = parseInt(productData.GiorniProduzione);
        } else if (productData.Fornitore) {
          fornitoreProdotto = productData.Fornitore;
          switch (fornitoreProdotto) {
            case 'Giuliana':
              produzioneSeDisponibile = 11;
              break;
            case 'Feng':
              produzioneSeDisponibile = 13;
              break;
            case 'Milva':
              produzioneSeDisponibile = 14;
              break;
            case 'Marco':
              produzioneSeDisponibile = 10;
              break;
            default:
              console.log('Fornitore non riconosciuto');
          }
        }

        // Caratteristiche del prodotto con la logica inalterata
        if (productData.PercToLabour) {
          icon = "";
          title = window.operacampithemeStrings.Spec_LabourTitle;
          get = "PercToLabour";
          recordToPass = parseInt(productData.PercToLabour) + "%";
          tooltip = window.operacampithemeStrings.Spec_LabourTooltip.replace(/"/g, '&quot;');
          createSpec(title, icon, recordToPass, tooltip);
        }
        
        if (productData.Weight) {
          get = "Weight";
          icon = ""
          title = window.operacampithemeStrings.Weight;
          recordToPass = productData.Weight + ' ' + window.operacampithemeStrings.Spec_Grams;
          tooltip = "";
          pesoProdotto = productData.Weight;
          createSpec(title, icon, recordToPass, tooltip);
        }

        if (productData.Lifespan) {
          icon = "";
          get = "Lifespan";
          title = window.operacampithemeStrings.Spec_Lifespan;
          recordToPass = productData.Lifespan;
          tooltip = window.operacampithemeStrings.Spec_Lifespan_Desc;
          createSpec(title, icon, recordToPass, tooltip);
        }

        if (productData.OreLavoro) {
          icon = "";
          title = window.operacampithemeStrings.Spec_OreLavoro;
          get = "OreLavoro";
          tooltip = "";
          recordToPass = '<var>' + productData.OreLavoro + '</var> ' + window.operacampithemeStrings.Spec_OreLavoro_Desc;
          createSpec(title, icon, recordToPass, tooltip);
        }

        if (productData.City) {
          icon = "";
          title = window.operacampithemeStrings.Spec_MadeIn;
          get = "City";
          tooltip = "";
          recordToPass = productData.City;
          createSpec(title, icon, recordToPass, tooltip);
        }

        if (productData.Sex) {
          icon = "";
          title = window.operacampithemeStrings.Spec_Sex;
          get = "Sex";
          tooltip = "";
          recordToPass = productData.Sex;
          createSpec(title, icon, recordToPass, tooltip);
        }

        if (productData.Fit) {
          icon = "";
          title = window.operacampithemeStrings.Spec_Fit;
          get = "Fit";
          tooltip = "";
          recordToPass = productData.Fit;
          createSpec(title, icon, recordToPass, tooltip);
        }

        if (productData.Dyeing) {
          icon = "";
          title = window.operacampithemeStrings.Spec_Dyeing;
          get = "Dyeing";
          tooltip = "";
          recordToPass = productData.Dyeing;
          createSpec(title, icon, recordToPass, tooltip);
        }

        if (productData.DesignedIn) {
          icon = "";
          title = window.operacampithemeStrings.Spec_Designed_in;
          get = "DesignedIn";
          tooltip = "";
          recordToPass = productData.DesignedIn;
          createSpec(title, icon, recordToPass, tooltip);
        }

        // Aggiornamento delle temperature min e max
        if (productData.MinTemp) {
          $("#minTemp").html(parseInt(productData.MinTemp) + "° C");
        }
        if (productData.MaxTemp) {
          $("#maxTemp").html(parseInt(productData.MaxTemp) + "° C");
        }
      } else {
        console.log('Prodotto non trovato.');
      }
      
      // Chiamate alle funzioni aggiuntive alla fine del processo
      updateProductShipping(variantSet, current_variant_colorSet, sectionIdSet);
      updateEmissions();
      enableTooltips();

    })
    .catch(error => console.error('Errore nel recupero dei dati:', error));




    /* END UPDATE PRODUCT SPECS */


    // URL dei fogli Google in formato CSV
const modelsUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTcEImGrI-pLYosSHQAbbLBXKJ02e4cEQnnewftPpnIH1hdKJpylBlmYdY-JHYfaZrMCHNWOZBvn1g-/pub?output=csv';
const modelsSizesUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQGHplL7GWPRi9ncMz-xqcriM5OCGpxGTHJaOWyuhtKpsIUiYSGE1mLOmxLObMYEm24mQH3Z6HAJ_Xi/pub?output=csv';

// Carica i dati dal foglio TaglieModelli e aggiorna la lista dei modelli
function loadModels() {
  fetch(modelsUrl)
    .then(response => response.text())
    .then(data => {
      const jsonData = csvToJson(data);
      const models = [];

      // Popola la lista dei modelli
      jsonData.forEach(record => {
        if (record.Name) {
          const modelloDettagli = {
            modello: record.Name,
            altezza: record.Altezza,
            peso: record.Peso,
            taglia: record.TagliaDefault,
            DescrizioneIT: record.DescrizioneIT,
            DescrizioneEN: record.DescrizioneEN
          };
          models.push(modelloDettagli);
        }
      });

      // Dopo aver caricato i modelli, chiama loadModelSizes
      loadModelSizes(models);
    })
    .catch(error => console.error('Errore nel caricamento dei modelli:', error));
}

// Carica i dati dal foglio TaglieProdotti e aggiorna le taglie del modello
function loadModelSizes(models) {
  fetch(modelsSizesUrl)
    .then(response => response.text())
    .then(data => {
      const jsonData = csvToJson(data);

      // Ciclo sui record delle taglie dei prodotti
      jsonData.forEach(record => {
        if (record.Model) {
const model = models.find(element =>
  element.modello.toUpperCase() === record.Model.toUpperCase() &&
  record.Handle === productHandle
);          
if (model) {
            model.taglia = record.Taglia;
          }
        }
      });

      // Finito tutto, aggiorna le didascalie
      updateCaptions(models);
    })
    .catch(error => console.error('Errore nel caricamento delle taglie dei modelli:', error));
}

// Aggiorna le didascalie con i dati dei modelli
function updateCaptions(models) {
  $(".modelGallery").each(function(index) {
    const modelloInfo = models.find(element => $(this).html().toUpperCase().includes(element.modello.toUpperCase()));
    if (modelloInfo) {
      $(this).html(
        window.operacampithemeStrings.Height + ": <var>" + modelloInfo.altezza + "</var> cm" +
        "<br/>" + window.operacampithemeStrings.Weight + ": <var>" + modelloInfo.peso + "</var> kg" +
        "<br/>" + window.operacampithemeStrings.Size + ": <var>" + modelloInfo.taglia + "</var>"
      );
      $(this).removeClass("d-none");
    }
  });
}

// Avvia il caricamento dei modelli e delle taglie
loadModels();


    //MODELS, prima li stilo
    // base2('Models').select({
    //   view: "Grid view"
    // }).eachPage(function page(records, fetchNextPage) {
      
    //   records.forEach(function(record,index) {

    //     if (record.get('Name')) {
    //       var modelloDettagli =
    //       {
    //         modello: record.get('Name'),
    //         altezza: record.get('Altezza'),
    //         peso: record.get('Peso'),
    //         taglia: record.get('TagliaDefault'),
    //         DescrizioneIT: record.get('DescrizioneIT'),
    //         DescrizioneEN: record.get('DescrizioneEN')
    //       }
    //       models.push(modelloDettagli);
    //     }
        
    //   });
      
    //   fetchNextPage();
    // }, function done(err) {
    //   //Altra chiamata per definire le taglie del modello per quel prodotto
    //   base2('Models_Sizes').select({
    //     view: "Grid view",
    //     filterByFormula: "{Handle} = '"+ productJson.handle + "'"
    //   }).eachPage(function page(records, fetchNextPage) {
    //     records.forEach(function(record,index) {
    //       if (record.get('Model')) {
    //         if (models.find(element => element.modello.toUpperCase() == record.get('Model').toUpperCase())) {
    //           models.find(element => element.modello.toUpperCase() == record.get('Model').toUpperCase()).taglia = record.get('Taglia');
    //         }
    //       }          
    //     });
        
    //     fetchNextPage();
    //   }, function done(err) {
    //     //Finito tutto aggiorno le caption
    //     $( ".modelGallery" ).each(function( index ) {

    //       if (models.find(element => $(this).html().toUpperCase().includes(element.modello.toUpperCase()) )) {
    //         var modelloInfo = models.find(element => $(this).html().toUpperCase().includes(element.modello.toUpperCase()) );
    //         $(this).html(
    //           window.operacampithemeStrings.Height + ": <var>"+modelloInfo.altezza + '</var> cm' + "<br/>"+ window.operacampithemeStrings.Weight +": <var>" + modelloInfo.peso + "</var> kg" + "<br/>"+ window.operacampithemeStrings.Size +": <var>" + modelloInfo.taglia + "</var>"
    //         );
    //         $(this).removeClass("d-none");
    //       }


    //     });
    //   });
  
    // });
  }
  


  function round2Decimals (numeroDaArrotondare) {
    return Math.round((numeroDaArrotondare + Number.EPSILON) * 100) / 100;
  }

  function updateEmissions() {
    var filatoTessuto = "filato";
    
    if (product_materiale.includes("filat")) {
      filatoTessuto = "filato";
    } else {
      filatoTessuto = "tessuto";
    }

    var emissioniTotali = {
      em_filatoNegative:0.0,
      em_filatoPositive:0.0,
      em_textileProduction:0.0,
      em_dyeing:0.0,
      em_manufacturing:0.0,
      em_delivery:0.0,
      em_plants:0.0
    }

    
    var emissioniNomiTooltip = {
      em_filatoNegative: [window.operacampithemeStrings.PlantsProcessing,window.operacampithemeStrings.PlantsProcessing_Desc,""],
      em_filatoPositive:[window.operacampithemeStrings.PlantsAbsorption,window.operacampithemeStrings.PlantsAbsorption_Desc,""],
      em_textileProduction:[window.operacampithemeStrings.Fabric,window.operacampithemeStrings.Fabric_Desc,""],
      em_dyeing:[window.operacampithemeStrings.Dyeing,window.operacampithemeStrings.Dyeing_Desc,""],
      em_manufacturing:[window.operacampithemeStrings.Sewing,window.operacampithemeStrings.Sewing_Desc,""],
      em_delivery:[window.operacampithemeStrings.Distribution,window.operacampithemeStrings.Distribution_Desc,""],
      em_plants:[window.operacampithemeStrings.Trees_planted,window.operacampithemeStrings.Trees_planted_Desc,""]
    }

    var percCanapa = 1;
    var percLana = 0;
    if (product_materiale.toLowerCase().includes("lanapa")) {
      percCanapa = 0.3;
      percLana = 0.7;
    } 

    if (product_materiale.toLowerCase().includes("cash")) {
      percCanapa = 0.5;
      percLana = 0.5;
    } 

    //PERSONALIZZATI
    //COGNE: 1.6mt di LANAPA, 0.7mt di TELA, 0.8 burro canapa naturale, imbottitura 1.8 mt = 4,9 metri totali, di cui 
    if (productJson.handle == "cogne") {
      percCanapa = 0.56;
      percLana = 0.44;
    }

    //Emissioni e assorbimenti materia prima
    if (pesoProdotto > 0) {
      var parteUtileFilato = 0.07; //7% perché c'è anche la tintura a volte
      var emissioneCo2CanapaKG = 0.1; //sarebbe 0,006
      var assorbimentoCo2CanapaKG = -1; //Assorbe 45kg di canapa per kg FILATO. 1 ton di canapa coltivata produce 70kg di canapa. 1 ettaro assorbe 12 tonnellate. 1 ettaro produce 12 ton
      emissioniTotali.em_filatoNegative =  (((pesoProdotto*percCanapa)/1000) / parteUtileFilato) * emissioneCo2CanapaKG;
      emissioniTotali.em_filatoPositive =  (((pesoProdotto*percCanapa)/1000) / parteUtileFilato) * assorbimentoCo2CanapaKG; //Da KG di materia prima ottengo 
      
      if (product_materiale.toLowerCase().includes("lanapa") || product_materiale.toLowerCase().includes("cash")) {
        var emissioneCo2LanaKG = 23;
        var parteUtileLana = 1;
        emissioniTotali.em_filatoNegative +=  (((pesoProdotto*percLana)/1000) / parteUtileLana) * emissioneCo2LanaKG;
      }
    } else {
      $("#featureIconsustainability").hide();
    }
    
    
    //Emissioni tessuto
    //if (filatoTessuto == "tessuto") {
      emissioniTotali.em_textileProduction = 0.495 * product_consumo;
    //}
    
    //Emissioni tintura
    if (pesoProdotto>0 && product_consumo > 0  && !current_variant_colorSet.toLowerCase().includes("raw") && !current_variant_colorSet.toLowerCase().includes("zero")   ) {
      emissioniTotali.em_dyeing = ((pesoProdotto/1000)*product_consumo)*1.1*2.5; //2.5 kg per tinto
    } else { //zero
      emissioniTotali.em_dyeing = 0;
    }

    //Emissioni manufacture e altro
    emissioniTotali.em_manufacturing = 15*(pesoProdotto/1000);
    emissioniTotali.em_delivery  = ((pesoProdotto/1000)*13)+1.5+7; //packaging e spedizione
    if (productJson.handle == "sacco") {
      emissioniTotali.em_delivery = emissioniTotali.em_delivery * 4;
    }
    
    emissioniTotali.em_plants = -80;
    
    //Emissioni acqua
    var waterUsage = 2700*((pesoProdotto*percCanapa)/1000);
    if (product_materiale.toLowerCase().includes("lanapa") || product_materiale.toLowerCase().includes("cash")) {
      waterUsage += 130 *((pesoProdotto*percLana)/1000);
    }
    $(".em_water").find(".image-feature-box-title").html(waterUsage.toFixed(2).toString() + " liters");

    //Stilizzo tutto
    var totaleEmissioni = 0;


    Object.keys(emissioniTotali).forEach(key => {
      totaleEmissioni += Math.abs(emissioniTotali[key]);
    });

    if (totaleEmissioni == 0 || emissioniTotali.em_filatoPositive == 0 || emissioniTotali.em_textileProduction == 0 ) {
      $("#featureIconsustainability").remove();
    } else {

    $(".netEmissions").text(parseInt(totaleEmissioni+emissioniTotali.em_filatoPositive*2+emissioniTotali.em_plants*2).toString() + "kg");
    
    $("#co2Less").text(
      ((parseInt(Math.abs(totaleEmissioni+emissioniTotali.em_filatoPositive*2+emissioniTotali.em_plants*2))
      /parseInt(totaleEmissioni+emissioniTotali.em_filatoPositive+emissioniTotali.em_plants))*100).toFixed(2)
      .toString() + "%");

      $("#co2LessCar").text((Math.abs(parseInt(totaleEmissioni+emissioniTotali.em_filatoPositive*2+emissioniTotali.em_plants*2))/0.47).toFixed(2).toString() + "km")
    

    Object.entries(emissioniTotali).forEach(([key, value], index) => {
       if($("."+key)) { //se è maggiore di zero ed esiste

        //Image feature box
        $("."+key).find(".image-feature-box-title").html(emissioniTotali[key].toFixed(2).toString() + "kg");
      }
    });

    

  }

    
    
    
  }
  
  function updateFromAirTableProductsFittings() {
    if (sizefinder) {
      var abbondanzeProductHandle = false;


      // URL del foglio Google Fittings in formato CSV
const fittingsUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTYSRNd-gpgTyFibZSBoE6kcFBqRY-mDLZgg-6pcJjzlwdpWbTe1Cy1sFo8jAoLXWttSIVaX0hikFYb/pub?output=csv';


// Carica i dati dal foglio Fittings e aggiorna le specifiche
  fetch(fittingsUrl)
    .then(response => response.text())
    .then(data => {
      const jsonData = csvToJson(data);
      let abbondanzeProductHandle = false;

      // Determina il sesso da verificare
      let sexToCheck = "Male";
      if (product_sex === 'man') {
        sexToCheck = "Male";
      } else if (product_sex === 'lady') {
        sexToCheck = "Female";
      } else {
        sexToCheck = $('input[type=radio][name="properties[Sex]"]:checked').val();
      }

      // Ciclo sui record del foglio Fittings
      jsonData.forEach(record => {
        if ((record.Handle === productJson.handle || record.Type === productJson.type || record.Handle === "Tutti") &&
            (record.Sex === sexToCheck || record.Sex === "Unisex")) {
          if (record.M) {
            fittings = [
              record.XXXS,
              record.XXS,
              record.S,
              record.M,
              record.L,
              record.XL,
              record.XXL,
              record.XXXL
            ];
          }
          if (record.AB_Slim) {
            $("#fit_slim").val(record.AB_Slim);
          }

          if (!abbondanzeProductHandle && record.AB_Regular) {
            $("#fit_regular").val(record.AB_Regular);

            // Se le abbondanze sono sul prodotto, prevalgono sul product type
            if (record.Handle === productJson.handle) {
              abbondanzeProductHandle = true;
            }
          }
        }
      });

      // Chiamate alle funzioni aggiuntive alla fine del processo
      measuresSizeUpdate();
      updateEmissions();
    })
    .catch(error => console.error('Errore nel caricamento dei fittings:', error));
      
    }
  }
  

  
  
  
  function changedColor(colorCellClass) {
    colorCellClass = colorCellClass.normalize("NFD").toLowerCase();
    //Da qui gestisco anche qualsiasi feature che possa riguardare il colore e la RIMUOVO
    $("[class*='colorFeature_']").hide();
    $("[class*='noColorFeature_']").show();
    $("[class*='materialFeature_']").hide();
    
    $('.colorFeature_'+ colorCellClass.replace(".detail_","").replace(" ","")).show();
    $('.noColorFeature_'+ colorCellClass.replace(".detail_","").replace(" ","")).hide();
    $('.materialFeature_'+ product_materiale.replace("_","")).show();

    // Tutte le immagini con classe "customImageColor" devono apparire se contengono nel src la variabile colorCellClass, e deve sparire "defaultImageColor" se ne trova almeno una
    // Seleziona tutte le immagini con la classe customImageColor
    var images = document.querySelectorAll('.customImageColor');

    // Traccia se viene trovata almeno un'immagine che corrisponde al criterio
    var imageFound = false;

    images.forEach(function(image) {
        // Controlla se l'attributo src dell'immagine contiene colorCellClass
        if (image.getAttribute('data-src').toLowerCase().includes(colorCellClass.replace(".detail_",""))) {
            // Mostra l'immagine
            image.style.display = 'block';
            imageFound = true;
        } else {
            // Nascondi l'immagine
            image.style.display = 'none';
        }
    });

    // Se viene trovata almeno un'immagine, nascondi defaultImageColor
    if (imageFound) {
        var defaultImages = document.querySelectorAll('.defaultImageColor');
        defaultImages.forEach(function(img) {
          if (!img.getAttribute('data-src').toLowerCase().includes(colorCellClass.replace(".detail_",""))) { 
            img.style.display = 'none';
          };
        });
    } else {
      var defaultImages = document.querySelectorAll('.defaultImageColor');
      defaultImages.forEach(function(img) {
          img.style.display = 'block';
      });
  }
  }
  
  
  //GESTIONE PHOTOSWIPE
  function initPhotoSwipe(elementDiv,pswpClass) {
    $('.'+pswpClass).remove();
    $("body").append('<!-- Root element of PhotoSwipe. Must have class pswp. --> <div class="pswp '+pswpClass+'" tabindex="-1" role="dialog" aria-hidden="true"> <!-- Background of PhotoSwipe. It\'s a separate element, as animating opacity is faster than rgba(). --> <div class="pswp__bg"></div> <!-- Slides wrapper with overflow:hidden. --> <div class="pswp__scroll-wrap"> <!-- Container that holds slides. PhotoSwipe keeps only 3 slides in DOM to save memory. --> <!-- don\'t modify these 3 pswp__item elements, data is added later on. --> <div class="pswp__container"> <div class="pswp__item"></div> <div class="pswp__item"></div> <div class="pswp__item"></div> </div> <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. --> <div class="pswp__ui pswp__ui--hidden"> <div class="pswp__top-bar"> <!-- Controls are self-explanatory. Order can be changed. --> <div class="pswp__counter"></div> <button class="pswp__button pswp__button--close pswp_close'+ pswpClass+'" title="Close (Esc)"></button> <button class="pswp__button pswp__button--share" title="Share"></button> <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button> <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button> <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR --> <!-- element will get class pswp__preloader--active when preloader is running --> <div class="pswp__preloader"> <div class="pswp__preloader__icn"> <div class="pswp__preloader__cut"> <div class="pswp__preloader__donut"></div> </div> </div> </div> </div> <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"> <div class="pswp__share-tooltip"></div> </div> <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"> </button> <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"> </button> <div class="pswp__caption"> <div class="pswp__caption__center"></div> </div> </div> </div> </div>');
    
    //https://webdesign.tutsplus.com/tutorials/the-perfect-lightbox-using-photoswipe-with-jquery--cms-23587
    var $pswp = $('.'+pswpClass)[0];
    var image = [];
    
    $(elementDiv).each( function() {
      var $pic     = $(this),
      getItems = function() {
        var items = []; 
        $pic.find('.swiper-slide:not(.swiper-slide-duplicate):not(.product-single__photo) a').each(function() {
          var $href   = $(this).attr('href'),
          $size   = $(this).data('size').split('x'),
          $width  = $size[0],
          $height = $size[1];
          // create slide object
          if ($(this).data('type') == 'video') {
            item = {
              html: $(this).data('video')
            };
          } else {
            item = {
              src : $href,
              w   : $width,
              h   : $height
            };
          }
          items.push(item);
        });
        return items;
      }
      
      var items = getItems();
      
      $pic.on('click', 'figure', function(event) {
        event.preventDefault();
      });
      
      $pic.on('click', 'figure', function(event) {
        event.preventDefault();
        
        var $index = $pic.find(".swiper-slide:not(.swiper-slide-duplicate):not(.product-single__photo) .carousel-photoswipe").index(this);
        var options = {
          index: $index,
          showHideOpacity: true
        }
        
        var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
        lightBox.init();
      });
    });
    
    
    
    $(".pswp_close"+ pswpClass).click(function(){
      $('iframe').attr('src', $('iframe').attr('src'));
    });
    
  }
  

  
  //RIORDINA FOTO IN BASE A COLORE E ALTRE CARATTERISTICHE
  function reorderSwiper(elementDiv) {
    var swiperContainer = $(elementDiv);
    var container = $(swiperContainer).find('.swiper-wrapper');
    var allDivs = $(container).find('.swiper-slide');
    var subsProds = [];   // Array con slide riordinate con priorità più alta (Sesso + Colore)
    var subsProds2 = [];  // Array con slide secondarie (Solo Sesso)
    var subsProds3 = [];  // Array con slide terziarie (Solo Colore)
    var remainingProds = []; // Array per le slide rimanenti
    var mainSlide = $(container).find(".main-product-thumb").toArray(); // Convertito in array
    var fakeSlide = $(container).find(".swiper-fake").toArray(); // Convertito in array

    // Distrugge il precedente slider
    const swiperElement = document.querySelector(elementDiv);
    if (swiperElement && swiperElement.swiper) {
        swiperElement.swiper.destroy();
    } else {
        console.log("Swiper non trovato o già distrutto.");
    }

    // Recupera sesso e colore selezionati
    var selectedSex = $('input[type=radio][name="properties[Sex]"]:checked').val()?.replaceAll(" ", "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    var selectedColor = $('.swatchRadio_color:checked').val()?.replaceAll(" ", "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replaceAll("lanapa", "");
    // Funzione per controllare se una slide ha il sesso corretto
    function matchSex(cName) {
        if (!selectedSex) return false; // Nessun sesso selezionato
        if (selectedSex === 'female') {
            return cName.includes(' female ');
        } else {
            return !cName.includes(' female '); // Default male
        }
    }

    // Funzione per controllare se una slide ha il colore corretto
    function matchColor(cName) {
        if (!selectedColor) return false;
        return cName.includes(selectedColor);
    }

    // Ciclo per classificare le slide
    allDivs.each(function () {
        var currentElement = $(this);
        var cName = ' ' + currentElement.attr('class').toLowerCase() + ' ';

        // Priorità 1: Sesso + Colore
        if (matchSex(cName) && matchColor(cName)) {
            subsProds.push(currentElement);
        }
        // Priorità 2: Solo Sesso
        else if (matchSex(cName)) {
            subsProds2.push(currentElement);
        }
        // Priorità 3: Solo Colore
        else if (matchColor(cName)) {
            subsProds3.push(currentElement);
        }
        // Slide rimanenti
        else {
            remainingProds.push(currentElement);
        }
    });

    // Aggiunge le slide al container in ordine di priorità
    [...remainingProds.reverse(), ...subsProds3.reverse(), ...subsProds2.reverse(), ...subsProds.reverse()].forEach(slide => {
        container.prepend(slide);
    });

    // Riordino slide principali e fake
    mainSlide.reverse().forEach(function (slide) {
        $(slide).detach().prependTo(container);
    });
    fakeSlide.reverse().forEach(function (slide) {
        $(slide).detach().prependTo(container);
    });
}

  
    //GALLERIA PRINCIPALE FOTO 
    function mainProductSlider(sliderDiv) { 
    
      var mySwiper = new Swiper (sliderDiv, {
              // Optional parameters
        lazy: {
          loadPrevNext:true,

          loadPrevNextAmount: 3
        },
        watchSlidesProgress: true,
        loop: true,
        // observeSlideChildren: true,
        // observer: true,
        spaceBetween: 5,
        updateOnImagesReady: true, 
        watchSlidesVisibility: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loopedSlides: 3,
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        
        
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        
        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      })
      
      mySwiper.on('lazyImageReady', function () {
        mySwiper.update();
      });
      
      
      initPhotoSwipe('#product-imagegallery','pswpBigGallery');
    }
    
  /*
  GALLERIA THUMBNAIL DI FIANCO AD ADDTOCART, LANCIATA IN PRODUCT-THUMBNAIL-IMAGE
  */
  
  
  function details_photo_slider() {

      
    var thumbsSwiper = new Swiper(".thumbsSwiper", {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      observer: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3
      },
      preloadImages: false
    });
    
    
    
    var detailsGalleryPicturesSwiper = new Swiper ('.product-single__photos', {
            // Optional parameters
            lazy: {
              loadPrevNext:true,
              loadPrevNextAmount: 3
            },
      watchSlidesProgress: true,
      loop: true,
      autoHeight: true,
      //observeSlideChildren: true,
      //observer: true,
      //spaceBetween: 5,
      updateOnImagesReady: true, 
      slidesPerView: "auto",
      centeredSlides: true,
      watchSlidesVisibility: true,
      loopedSlides: 3,
      
      thumbs: {
        swiper: thumbsSwiper,
      },
      
      // If we need pagination
      /*pagination: {
        el: '.swiper-pagination',
      },*/
      
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
    })
    
    detailsGalleryPicturesSwiper.on('lazyImageReady', function () {
      detailsGalleryPicturesSwiper.update();
    });
    
    //$(".swiper-pagination,.swiper-button-next,.swiper-button-prev").show();
    initPhotoSwipe('.product-single__photos','pswpThumbGallery');
    
  }
   
  
  function reInitGalleries() {
    //riordina galleria in base alla scelta
    reorderSwiper('.product-single__photos');
    
    if($("#product-imagegallery").is(":visible")){
      reorderSwiper('#product-imagegallery');
    } else {
      reorderSwiper('.thumbsSwiper');
    }
    
    //rebuild slider with new images
    if($("#product-imagegallery").is(":visible")){
      mainProductSlider('#product-imagegallery');
    }
    details_photo_slider();

    //reinit videos
    window.addEventListener('load', (event) => {
      startObserving();
    });

  }


  function updateSexSettings() {
    //NASCONDE CIò CHE HA SESSO FEMMINA E MASCHIO IN BASE ALLE CLASSI
    // Seleziona tutti gli elementi con la classe ".feature_lady"
    const featureLadyElements = document.querySelectorAll('.element_lady');
    const featureManElements = document.querySelectorAll('.element_man');
    const featureUnisexElements = document.querySelectorAll('.element_unisex');

    // Nasconde ciascun elemento iterando sulla NodeList
    featureLadyElements.forEach(element => {
      element.style.removeProperty('display');
    });
    featureManElements.forEach(element => {
      element.style.removeProperty('display');
    });
    featureManElements.forEach(element => {
      element.style.removeProperty('display');
    });

    /*SE ARRIVA DA COLLEZIONE LADIES imposta ladies*/
    if (localStorage.getItem("visitorSex") == "lady") {
      $( "input[value=Female]" ).prop( "checked", true );
      //product_sex = "lady";
      featureManElements.forEach(element => {
        element.style.display = 'none';
      }); 
      //$('.swatchRadio_color,input[type=radio][name="properties[Sex]"]').trigger("change");
    } else if (localStorage.getItem("visitorSex") == "man") {
      $( "input[value=Male]" ).prop( "checked", true );
      //product_sex = "man";
      featureLadyElements.forEach(element => {
        element.style.display = 'none';
      }); 
     } else {

     }

      //Se non ci sono look nascondo il bottone
      const productLooksDivs = document.querySelectorAll('.productLook');

      // Controlla se tutti i <div> hanno display: none
      const allHidden = Array.from(productLooksDivs).every(div => {
          return window.getComputedStyle(div).display === 'none';
      });

      // Se tutti i <div> sono nascosti, esegui qualcosa
      if (allHidden) {
          $("#btnLook").hide();
      } else {
        $("#btnLook").show();
      }

  }


  function tagliaInizialeAutomatica() {
       // Verifica se il primo radio della taglia è attualmente selezionato
       const firstSwatch = document.querySelector(".sizeSwatchGroup .swatch-group .swatch-element");
       const firstRadio = firstSwatch ? firstSwatch.querySelector("input[type='radio']") : null;
       if (!firstRadio || !firstRadio.checked) {
           return; // Esce se il primo elemento radio non è selezionato
       }
   
       // Recupera la taglia suggerita dal localStorage
       let suggestedSize = localStorage.getItem("suggestedSize");
       if (!suggestedSize || suggestedSize.trim() === "") {
           suggestedSize = null;
           measuresSizeUpdate(); //Lancio measure size update solo se non c'è già
       }
   
       if (!suggestedSize || suggestedSize.trim() === "") {
         suggestedSize = null;
       }
       
       // Cerca la taglia suggerita disponibile
       let preferredSwatch = suggestedSize ? 
           document.querySelector(`.sizeSwatchGroup .swatch-group .swatch-element[data-value='${suggestedSize.toUpperCase()}']:not(.soldout)`) : 
           null;
       
       // Se la taglia suggerita non è disponibile o non esiste, cerca la taglia M
       if (!preferredSwatch) {
           preferredSwatch = document.querySelector(".sizeSwatchGroup .swatch-group .swatch-element[data-value='M']:not(.soldout)");
       }
       
       // Se la taglia M non è disponibile, seleziona la prima disponibile
       if (!preferredSwatch) {
           preferredSwatch = document.querySelector(".sizeSwatchGroup .swatch-group .swatch-element:not(.soldout)");
       }
       
       if (preferredSwatch) {
           const radioInput = preferredSwatch.querySelector("input[type='radio']");
           if (radioInput) {
               radioInput.checked = true;
               radioInput.dispatchEvent(new Event("input", { bubbles: true }));
               radioInput.dispatchEvent(new Event("change", { bubbles: true }));
               radioInput.dispatchEvent(new Event("click", { bubbles: true }));
               
               // Trova la select correlata e attiva l'evento change
               const selectElement = document.querySelector(".single-option-selector");
               if (selectElement) {
                   selectElement.value = radioInput.value;
                   selectElement.dispatchEvent(new Event("change", { bubbles: true }));
               }
           }
       }
  }
 

  
  document.addEventListener('DOMContentLoaded', function() { //prima ottobre 2024 usavo $(window).on('load', function() {
        /*IF BY ALBY CHE SPOSTA I COLORI */
      // if($(".swatch_to_move").length) {
      //   $('.swatch_to_move').each(function() {
          
      //     var htmlcolors = $(this).html();
      //     $("#colorsoptions").html($("#colorsoptions").html() + htmlcolors);
      //     $(this).remove();
      //     enableTooltips();   
    
      //   });
      // }
      //SWATCHES CHE QUANDO CAMBIA AGGIORNA IL SELECT - delicato testare sempre su ipad, iphone e mac
      $('.swatch :radio').on('click', function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');

    });


        //DEBUG FORM
        const form = document.getElementById('product_form');
        form.addEventListener('submit', function(event) {

          //Rimuovo proprietà vuote
          const inputs = form.querySelectorAll('input.ShopifyProperty[name^="properties["]');
      inputs.forEach(function (input) {
        if (!input.value || input.value.trim() === "" || input.value.trim() === "0") {
          input.parentNode.removeChild(input);
        }
      });

            // Ottieni i dati del form
            const formData = new FormData(form);
            // Itera sui dati e loggali
            console.log("Form Data:");
            for (const [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }


        });

    //PRODUCT GALLERY 
    localStorage.setItem('galleryHtml', $('#product-imagegallery').html());
    //Filtro gallery_few_images
    //when filter buttons clicked MALE / FEMALE
    //https://codepen.io/jeffglenn/details/YYwMao 
    var slider = $('#product-imagegallery'); 
    var filterButtons = $('.filterButtons');
    filterButtons.on( 'click', 'label', function() {
      $('#product-imagegallery').html(localStorage.getItem('galleryHtml'));

      //use data-filter attribute & class for filtering
      var filterValue = $( this ).attr('data-filter');
      var slide = slider.find('.slide');
      
      if (filterValue == 'all') {
        // if all show all
        slide.fadeIn(450);
      } else {
        //set active slide
        var active = $('.' + filterValue).fadeIn(450);
        // show only slide with the same class as the button "attr('data-filter')"

        $( slide.not(active) ).each(function( index ) {
          $(this).remove();
        });

      }
      
      // destroy slider so we can rebuild with new filters
      const swiper = document.querySelector('#product-imagegallery').swiper;
      swiper.destroy();
      
      //rebuild slider with new images
      setTimeout(reInitGalleries, 100); 
      
  });

    
    if ($(".sizeSwatchGroup").length || $(".colorSwatchGroup").length) {
      updateFromAirTableMaterials();
      updateFromAirTableProductsFittings();
    }
     
    //SWITCH COLORE RE-FILTRA IMMAGINI
    $('.swatchRadio_color,input[type=radio][name="properties[Sex]"]').change(function() {      
      switch ($('input[type=radio][name="properties[Sex]"]:checked').val()) {
        case 'Male':
        localStorage.setItem("visitorSex", "man");
        //product_sex = "man";
        break;
        case 'Female':
        localStorage.setItem("visitorSex", "lady");
        //product_sex = "lady";
        break; 
      }   
      updateSexSettings();     
      reInitGalleries(); //Per riordinarle 
      updateProductShipping(variantSet, current_variant_colorSet, sectionIdSet);

    });
    
    updateSexSettings();

    setTimeout(reInitGalleries, 400);   
    
    

    //CREA LINK AUTOMATICI (MOON BUTTON)
      const descriptionDiv = document.querySelector(".product-single__description");
      const modalExists = document.querySelector('[data-remodal-id="moonbutton"]'); // Controlla se esiste il modal
  
      if (descriptionDiv && modalExists) {
          const regex = /\b(Moon Button|moon buttons)\b/gi; // Cerca entrambi in modo case-insensitive
          const walker = document.createTreeWalker(descriptionDiv, NodeFilter.SHOW_TEXT, null, false);
  
          let node;
          while ((node = walker.nextNode())) {
              if (regex.test(node.nodeValue)) {
                  const parent = node.parentNode;
                  if (parent.tagName !== "A") { // Controlla che non sia già dentro un link
                      const newHtml = node.nodeValue.replace(regex, function (match) {
                          return `<a href="#moonbutton" class="moon-button-link">${match}</a>`;
                      });
                      const span = document.createElement("span");
                      span.innerHTML = newHtml;
                      parent.replaceChild(span, node);
                  }
              }
          }
      }  


      setTimeout(tagliaInizialeAutomatica,300);



    });


  /* 
  GESTIONE MISURAZIONI
  */

  //CONFIGURATION
if (!fittings) {
  var fittings = new Array();
  fittings[0] = 0.30;
fittings[1] = 0.317;
fittings[2] = 0.34;
fittings[3] = 0.375;
fittings[4] = 0.449;
fittings[5] = 0.5;
fittings[6] = 0.52;
fittings[7] = 0.54;
}
/*
CONFIGURATION MADE DYNAMICALLY WITH PRE-CALCULATED AI
SHOPIFY DYNAMIC ASSET GENERATOR
*/

//Transform any not valid number in 0; Replace , with .
function validateNumber(number) {
  if(number == "") {
    number = 0;
  } else if($.isNumeric(number)) {
    number = number.replace(",",".");
  } else {
    number = 0;
  }
  return parseFloat(number);
} 


function updateSuggestedSize(taglia,alertStrangeSize,alertInsertMore) {
  if(taglia == "BAD") {
    $("#sizeSuggest").html(window.operacampithemeStrings.ImpossibleCalculate);
    $("#confirmSuggestedSize").hide();
  } else if (alertStrangeSize) {
    $("#sizeSuggest").html(window.operacampithemeStrings.ImpossibleMeasures + taglia);
    $("#confirmSuggestedSize").hide();
  } else if (alertInsertMore) {
    $("#sizeSuggest").html(window.operacampithemeStrings.FewMeasures);
    $("#confirmSuggestedSize").hide();
  } else {
    $("#sizeSuggest").html(window.operacampithemeStrings.YourSize + " <span id='theSize'>" + taglia + " " + sizeSplitToAdd + "</span>");
    $("#confirmSuggestedSize").attr("sizeToClick",taglia); //Da correggere in caso di split size
    $("#confirmSuggestedSize").attr("splitToClick",sizeSplitToAdd); //Da correggere in caso di split size
    $("#confirmSuggestedSize").show();
    $("#TagliaSuggeritaProperty").val(taglia); //Imposto il valore della taglia suggerita per il form
    localStorage.setItem("suggestedSize",taglia);
  }
}



var sizingTable = $("#sizing"); //tabella
var cminch;
var cminchBoolean;
var sizeSplitToAdd = ""; //aggiungo una stringa per una misura che è calcolata con uno split esempio inseam pantaloni


$( document ).ready(function() {



  //Traduco eventuali contenuti tabella misure
  $('#sizing td,#sizing th,.measureContent').each(function(){
    if (currentLanguage.toLowerCase() !== 'en') {
      switch($(this).html()) {
        case "Sizes":
        $(this).html(window.operacampithemeStrings.Sizes);
        break;
        case "Inseam":
        $(this).html(window.operacampithemeStrings.Inseam);
        break;
        case "Front length":
        $(this).html(window.operacampithemeStrings.frontLength);
        break;
        case "Shoulders":
        $(this).html(window.operacampithemeStrings.Shoulders);
        break;
        case "Sleeve":
        $(this).html(window.operacampithemeStrings.Sleeve);
        break;
        case "Chest":
        $(this).html(window.operacampithemeStrings.Chest);
        break; 
        case "Hips": 
        $(this).html(window.operacampithemeStrings.Hips);
        break;
        case "Thigh": 
        $(this).html(window.operacampithemeStrings.Thigh);
        break;
        case "Waist": 
        $(this).html(window.operacampithemeStrings.Waist);
        break;
        case "Width": 
        $(this).html(window.operacampithemeStrings.Width);
        break;
        case "Height": 
        $(this).html(window.operacampithemeStrings.Height);
        break;
      }
    }
  });

  //Reimposto eventuali valori memorizzati nello storage
  $( ".sizeFinderMeasure" ).each(function( index ) {
    var measureId = $(this).attr("id");
    /*Set storage if there's storage*/
    if (localStorage.getItem(measureId) === null) {
    } else {
      if($(this).attr("type") == "radio" ) {
        $(this).prop("checked", true);
      } else {
        $(this).val(localStorage.getItem(measureId));
      }
    }
  });

  
  //Imposto valore radio
  $(document).ready(function() {
  const stored = localStorage.getItem("abundancyMode");
  const current = $("input[name='abundancy']:checked").prop("id");

  if (stored && stored !== current && $("#" + stored).length > 0) {
    $("#" + stored).prop("checked", true).trigger("change");
  } else if (!stored) {
    localStorage.setItem("abundancyMode", current);
  }
});

  $("#widthHeightInputs").hide();

  if($("input[name=cminch]").length) {
    cminch = parseInt($("input[name=cminch]:checked").val()); //0 cm , 1 inch
    if(cminch == 0 || cminch == undefined) {cminchBoolean = false;} else {cminchBoolean = true;} //false cm, true inches
  } else {
    cminchBoolean = false;
  }
  resetCmInch(true);

  $(document).on('opened', '#sizingTreatmentsModal', function () {
    updateFromAirTableProductsFittings();
    });

  //measuresSizeUpdate(); spostato all'apertura del modal

  //TABS


  /* Seleziono taglia e chiudo al click */
  $( "#confirmSuggestedSize").on( 'click', function() {
    var tagliaFinale = $( "#confirmSuggestedSize").attr("sizeToClick").replace("A","Y");
    var splitToClick = $( "#confirmSuggestedSize").attr("splitToClick");
    $('.swatch').find("input[value='"+tagliaFinale+"']").click();
    $('.swatch').find("input[value='"+splitToClick+"']").click();
    $('.remodal-close').click();
  });

  /* Sposto i vari contenuti nei tab giusti! */
  //$("h2[data-table-section=Evolution]").nextUntil("h2:contains('End')").addBack().appendTo('#evolution');

  $("#sizing").addBack().appendTo('#sizingTable');
  $("#sizing").wrap("<div class='responsive-table'></div>");


  //$("h2:contains('End')").remove();

});


function measuresSizeUpdate() {
  var suggestedSize = 0; //Parte da 0 e aumenta, ma mai diminuisce per ogni volta che faccio il calcolo.
  var alertStrangeSize = false; //Abilitato se le misure vanno fuori la tabella
  var alertInsertMore = false; //Abilitato se le misure sono insufficienti come numero
  var countEmptySizingMeasures = 0; //conta misure vuote
  var countSizingMeasures = 0; //conta misure inserite
  var countFillSplitMeasures = 0; //conta misure split fisse inutili al calcolo della taglia globale
  var countUnusefulSizingMeasures = 0; //conta misure che non sono in tabella o che sono vuote o che non servono
  var trCount = $("#sizing tr").length-1;
  var sizesToAdd = 0; //aggiungo/rimuovo taglia all'ultimo in base al fitting


  $( "#confirmSuggestedSize").hide();

//PRIMO SCORRIMENTO MISURE INPUT
//mi scorro una prima volta le misure per escluderle dal CALCOLO
$( ".sizeFinderMeasure" ).each(function( index ) {
  var measureValue = validateNumber($(this).val()); //Restituisce 0 se son caratteri, vuoto o 0.
  var measureName = $(this).attr("sizingTableName");
  var measureID = $(this).attr("id");

  //Prendo EQ (indice colonna) della misura digitata, se non esiste nella sizing table
  var EQmisure = $(sizingTable).find("th[data-table-measure=" + measureName + "]").index() - 1;
  if (EQmisure < 0) {
    //Se c'è l'attributo sizingTableName ma non c'è in tabella misura non mi serve!
    if($(this).attr("sizingTableName")) {
      $('#' + $(this).attr("sizingTableName") + 'Input').remove();
    }
    countUnusefulSizingMeasures++;
  }

  //Altro caso in cui devo eliminare l'input, se ho i fianchi ma voglio escluderli dal CALCOLO
  //Evito hips se c'è personalizzazione es. sweater two SPOSTATO SOPRA DOVE RIMUOVO GLI INPUT
  //Evito shoulders anche
  if (measureID == "HipsTextInput" && AvoidHips) {
    $("#HipsInput").remove()
    countUnusefulSizingMeasures++; //Conto l'Hips come se non servisse
  }
  if (measureID == "ShouldersTextInput" && AvoidShoulders) {
    $("#ShouldersInput").remove()
    countUnusefulSizingMeasures++; //Conto le shoulders come se non servisse
  }

});

//SECONDO SCORRIMENTO MISURE INPUT
//Ora mi scorro nuovamente gli input misure per il calcolo
  $( ".sizeFinderMeasure" ).each(function( index ) {
    var measureValue = validateNumber($(this).val()); //Restituisce 0 se son caratteri, vuoto o 0.
    var measureName = $(this).attr("sizingTableName");

    var measureID = $(this).attr("id");

    var weightInput = $("#user_weight").val();
    var heightInput = $("#user_height").val();
    var EQmisure = $(sizingTable).find("th[data-table-measure=" + measureName + "]").index() - 1;

    //Aggiorno proprietà misure per avere l'info nell'ordine
    if($("#SF" + measureID.replace("TextInput",""))) {
      $("#SF" + measureID.replace("TextInput","")).val(measureValue);
    }

    /*Update the storage*/
    if($(this).attr("type") == "radio" ) {
      if ($(this).is(':checked')) {
        localStorage.setItem(measureID, "checked");
      } else {
        localStorage.removeItem(measureID);
      }
    } else {
      localStorage.setItem(measureID, measureValue); 
    }

    //Se c'è una misura che non appartiere alla tabella misure passo
    if (EQmisure < 0) {
      countUnusefulSizingMeasures++;
      return;
    }


     $("#SizeFinderMethodProperty").val("Misure corpo");


    //Setto l'abbondanza.
    var abundancyValue = parseFloat($("input[name='abundancy']:checked").val());
    if (abundancyValue == 0) {
      //Se è uguale 0 allora è calcolo solo con AI
      //abundancyValue = AIabundancy();
      abundancyValue =  $("#fit_regular").val();

      //Se non ho inserito height and weight non posso proseguire
      if (weightInput == "" || heightInput == "" || weightInput == "0" || heightInput == "0") {$("#sizeSuggest").text(window.operacampithemeStrings.AutomaticCalc); return false;}

      /*
      CALCOLO AUTOMATICO: imposto la taglia di partenza con altezza e peso
      */
     $("#SizeFinderMethodProperty").val("Calcolo con altezza e peso");
     var suggestedAiSize = AIoldMethod();
     if (suggestedAiSize > suggestedSize) {
      suggestedSize = suggestedAiSize; //Procedo a indovinare la taglia senza altre misure
     }
      //return false;

    }

    //OVERSIZE SEMPRE UNA TAGLIA IN PIU'
    if($("#fit_oversize").is(':checked')) {
      abundancyValue = parseFloat($("#fit_regular").attr("value"));
      sizesToAdd = 1;
    }


    var noCheckAlertStrangeSize = false; //Non controllare se è misura strana

    //Per le spalle un trattamento differente
    if (measureID == "ShouldersTextInput") {
      noCheckAlertStrangeSize = true;
      //Per le spalle rimuovo abbondanza solo in caso di tessuti fermi cioè abbondanza positiva.
      if(abundancyValue > 0.00) {
        abundancyValue = abundancyValue * 0.00;
      }
    }

    //Per la gamba internaa un abbondanza fissa del 0,05
    if (measureID == "InseamTextInput") {
      noCheckAlertStrangeSize = true;
      abundancyValue = 0.04;
  }

    //Per gli inps abbondanza fissa del 5,5%
    if (measureID == "HipsTextInput") {
      abundancyValue = 0.055;
    }

    //Per gli inps abbondanza fissa del 10%
    if (measureID == "ThighTextInput") {
      noCheckAlertStrangeSize = true;
      abundancyValue = 0.07;
    }

    
    //Se è la misura è 0 o vuoto è inutile che lo cerchi nella tabella ed proseguo all'each successivo.
    if (measureValue == 0.00 || measureValue == "") {
      $(this).val(""); //se è 0 diventa vuoto!
      //Se tutte le misure (non altezza e peso) sono 0 o vuote ma l'abbondanza è impostata su AI, allora passo al metodo traditionale.
      if($(this).hasClass("sizeFinder_sizingMeasure")) {
        countEmptySizingMeasures++;
      }


      if ($( ".sizeFinder_sizingMeasure" ).length == countEmptySizingMeasures) { //Le misure sono tutte vuote
        //AIoldMethod(); //Procedo a indovinare la taglia senza altre misure
        return false;
      }

      countUnusefulSizingMeasures++;
      return;
    } else {
      //Misura inserita

      if($(this).hasClass("sizeFinder_splitMeasure")) { //Controllo se ci sono misure split aggiunte
        countFillSplitMeasures++;
      }
      countSizingMeasures++;
    }


    if($("#fit_garment").is(':checked')) {
      abundancyValue = parseFloat($("#fit_garment").attr("value"));
      //Tutti i div con classe fit_Garment devono apparire
      $(".fit_garment").show();
      $(".fit_body").hide();
      $("#SizeFinderMethodProperty").val("Misure capo simile");
    } else {
      $(".fit_body").show();
      $(".fit_garment").hide();
    }



    //Setto la variabile che dice se è una splitted measure (es. Inseam) prima dell'each di ogni valore
    var splittedMeasure = $(this).hasClass("sizeFinder_splitMeasure");

    //Passo ogni TD della colonna della misura specificata
    $(sizingTable).find('tr').each(function(){
      var td = $(this).children('td').eq(EQmisure);

      //Valore della cella trovata in corrispondenza della misura che è stata inserita
      var tdValue = td.text();

      //Se è una misura fissa splittata es. inseam dei pantaloni allora semplicemente controllo in quale split si trova!
      if (splittedMeasure && tdValue.includes("|")) {
        var ArraySplitMeasures = tdValue.split('|').map( Number );
        var measureToVerify = parseFloat(measureValue) + (parseFloat(measureValue) * abundancyValue); //Difficile ci sia abbondanza in split measures

        var splittedMeasureCorrect = ArraySplitMeasures[0];
        var indexSplitMeasureCorrect = 0;
        ArraySplitMeasures.forEach(function(element,index) {
          if (measureToVerify >= element) {
            splittedMeasureCorrect = element;
            indexSplitMeasureCorrect = index;
          }
        });

        //Per ora ipotizzato solo per l'inseam pantaloni
        switch(indexSplitMeasureCorrect) {
          case 0:
          sizeSplitToAdd = "Short"
          break;
          case 1:
          sizeSplitToAdd = "Regular"
          break;
          case 2:
          sizeSplitToAdd = "Tall"
          break;
          default:
          sizeSplitToAdd = "Short"
        }

      }else {
        //DA QUI PARTE IL CONTROLLO PER LE MISURE CLASSICHE NON FISSE SPLITTATE


        //Controllo che il valore della cella sia una misura e dunque un numero

        if($.isNumeric(tdValue)) {
          tdValue = parseFloat(tdValue);
        } else {
          return; //non è numerico, vado al prossimo each
        }

        //AGGIUNGO ABBONANZA
        var measureToVerify = parseFloat(measureValue) + (parseFloat(measureValue) * abundancyValue);


        /*Parto con il controllo della tabella: gli step sono 3 IF
        1) la misura è molto minore rispetto alla prima taglia disponibile
        2) la misura sta nel mezzo
        3) la misura è molto sopra l'ultima taglia disponibile
        */
        if ($(this).is(':nth-child(2)') && measureToVerify < tdValue) {
          //Se è molto piccolo consigliamo la prima taglia oppure un su misura se è molto diverso oltre 2cm
          if ((tdValue - measureToVerify) >= 10 && !noCheckAlertStrangeSize) {
            alertStrangeSize = true;
          }
          //Ho trovato la taglia per questa misura!
          var tagliaCorrettaPerMisura = $(this).index();
          /* Se il valore della misura inserito con abbondanza è maggiore o uguale della misura del TD allora la taglia è quella giusta, controllo però che il precedente suggested size non sia più alto, perché allora tengo quello */
          if(tagliaCorrettaPerMisura > suggestedSize) {
            suggestedSize = $(this).index();
          }
          return false; //Rompo l'each, ho già trovato la taglia per questa misura!
        } else if(tdValue >= measureToVerify) {
          //Ho trovato la taglia per questa misura!
          var tagliaCorrettaPerMisura = $(this).index();
          /* Se il valore della misura inserito con abbondanza è maggiore o uguale della misura del TD allora la taglia è quella giusta, controllo però che il precedente suggested size non sia più alto, perché allora tengo quello */
          if(tagliaCorrettaPerMisura > suggestedSize) {
            suggestedSize = $(this).index();
          }
          return false; //Rompo l'each, ho già trovato la taglia per questa misura!
        } else if ($(this).is(':last-child') && measureToVerify > tdValue) {
          //Se è oversize consigliamo l'ultima taglia oppure un su misura se è molto diverso oltre 2cm
          if ((measureToVerify - tdValue) >= 10 && !noCheckAlertStrangeSize) {
            alertStrangeSize = true;
          }
          //Ho trovato la taglia per questa misura!
          var tagliaCorrettaPerMisura = $(this).index();
          /* Se il valore della misura inserito con abbondanza è maggiore o uguale della misura del TD allora la taglia è quella giusta, controllo però che il precedente suggested size non sia più alto, perché allora tengo quello */
          if(tagliaCorrettaPerMisura > suggestedSize) {  suggestedSize = $(this).index(); }
          return false; //Rompo l'each, ho già trovato la taglia per questa misura!
        }

      }

    });

    //Se ha inserito solo taglie SPLIT dà errore!
    if (countFillSplitMeasures == countSizingMeasures) {
      alertInsertMore = true;
    }


    //Scrivo i suggerimenti taglia
    var tagliaFinale = $(sizingTable).find( "tr" ).eq(suggestedSize).find('th').text();
    updateSuggestedSize(tagliaFinale,alertStrangeSize,alertInsertMore);
  });

  //Aggiunto sizestoAdd
  if(suggestedSize < trCount && suggestedSize > 0) {
    suggestedSize = suggestedSize + sizesToAdd;
    var tagliaFinale = $(sizingTable).find( "tr" ).eq(suggestedSize).find('th').text();
    updateSuggestedSize(tagliaFinale,alertStrangeSize,alertInsertMore);
  }

}



function AIoldMethod () {
  var weight = validateNumber($("#user_weight").val());
  var height = validateNumber($("#user_height").val());

  //Se siamo negli inches converto in cm
  if (cminchBoolean) {
    height = convertInchToCm(height);
  }

  //Update fitting table with classes based on size
  var sizes = new Array();
  $(".size").each(function () {
    $(this).addClass("size" + $(this).html());
    sizes.push($(this).html());
  })

  Number.prototype.between = function(first,last){
    return (first < last ? this >= first && this <= last : this >= last && this <= first);
  }


  function extendedSize(size) {
    size = size.toUpperCase();
    switch(size) {
      case "XXXS":
      return "XXX Small";
      break;
      case "XXS":
      return "XX Small";
      break;
      case "XS":
      return "Extra Small";
      break;
      case "S":
      return "Small";
      break;
      case "M":
      return "Medium";
      break;
      case "L":
      return "Large";
      break;
      case "XL":
      return "Extra Large";
      break;
      case "XXL":
      return "XX Large";
      break;
      case "XXXL":
      return "XXX Large";
      break;
      default:
      return "Medium";
    }
  }

  //Da rivedere
  //CALCOLO VALORE
  var thevalue = weight/height;
  var correctsize;

  //Imposto size di partenza (Fittings sono specificate in product.js e partono da XXXS)
  var fittingsToStart = 0;
  switch(sizes[0]) {
    case "XXXS":
    fittingsToStart = 0;
    break;
    case "XXS":
      fittingsToStart = 1;
      break;
    case "XS":
      fittingsToStart = 2;
      break;
    case "S":
      fittingsToStart = 3;
      break;
    default:
      fittingsToStart = 0;
    }


  for(i=0;i<=sizes.length;i++) {
    if(i==0) {
      if(thevalue<=fittings[i+fittingsToStart]) {
        correctsize = sizes[sizes.length-(sizes.length-i)];
      }
    }

    if(i>0 && i<sizes.length) {
      if(thevalue.between(fittings[i+fittingsToStart-1],fittings[i+fittingsToStart])) {
        correctsize = sizes[sizes.length-(sizes.length-i)];
      }
    }

    if(i==sizes.length) {
      if(thevalue>fittings[fittings.length-1]) {
        correctsize = sizes[sizes.length-1];
      }
    }

    //updateSuggestedSize(correctsize,false);
  }

  if(weight<40 && weight>0 || height<140 && height>0) {
    updateSuggestedSize("BAD",true);
    return 0;
  } else if (weight<=0 || height <=0) {
    updateSuggestedSize("BAD",false);
    return 0;
  } else {
    if (sizes.indexOf(correctsize) >= 0) {
      return sizes.indexOf(correctsize)+1;
    } else {
      return 0;
    }
  }


  

}

$( ".sizeFinderMeasure" ).keyup(function() {
  measuresSizeUpdate();
});

$('input[type=radio][name=abundancy]').change(function() {
  //Mostro altezza e peso solo se c'è dell'AI
  if(parseFloat($("input[name='abundancy']:checked").val()) == 0) {  $("#widthHeightInputs").show();} else {  $("#widthHeightInputs").hide();}
  //Imposta nel local storage l'id dell'elemento html radio button
  localStorage.setItem("abundancyMode", $("input[name='abundancy']:checked").prop("id"))

  measuresSizeUpdate();
});


function convertCmToInch(value) {
  if (value.toString().includes("|")) {
    var splitValue = "";
    var ArraySplitMeasures = value.split('|').map( Number );
    ArraySplitMeasures.forEach(function(element) {
      element = parseFloat(element.toString().replace(',', '.')) * 0.393700;
      if(element == "0" || element == "") {return;}
      if (splitValue != "") {splitValue = splitValue + "|"}
      splitValue = splitValue + (Math.round(element * 100) / 100).toString();
    });

    return splitValue;


  } else {
    value = parseFloat(value.toString().replace(',', '.')) * 0.393700;
    valueRounded =Math.round(value * 100) / 100;
    return valueRounded;
  }

}

function convertInchToCm(value) {
  if (value.toString().includes("|")) {
    var splitValue = "";
    var ArraySplitMeasures = value.split('|').map( Number );
    ArraySplitMeasures.forEach(function(element) {
      element = parseFloat(element.toString().replace(',', '.')) / 0.393700;
      if(element == "0" || element == "") {return;}
      if (splitValue != "") {splitValue = splitValue + "|"}
      splitValue = splitValue + (Math.round(element * 100) / 100).toString();
    });

    return splitValue;


  } else {
    value = parseFloat(value.toString().replace(',', '.')) / 0.393700;
    valueRounded =Math.round(value * 100) / 100;
    return valueRounded;
  }
}

//CHANGE INCH AND CM
function resetCmInch(firstLoad = false) {

  //Change sizing table.
  if(firstLoad) { //se è FIRST LOAD allora la tabella è in CM e devo convertirla se è inches.
    $("#sizing td").each(function () {
      if(parseFloat($(this).text()) > 0 || $(this).html().includes("|")) {
        if(cminchBoolean) {
          var value = convertCmToInch(parseFloat($(this).text()));
          $(this).html(value);
        }
      }
    })
  } else {
    $("#sizing td").each(function () {
      if(parseFloat($(this).text()) > 0 || $(this).html().includes("|")) {
        if(cminchBoolean) {
          var value = convertCmToInch(parseFloat($(this).text()));
          $(this).html(value);
        } else {
          var value = convertInchToCm(parseFloat($(this).text()));
          $(this).html(value);
        }
      }
    })
  }

  //Change values in length measures inputs
  if(firstLoad) { //se è first load ho già i valori memorizzati nel local storage!
    $(".sizeFinder_sizingMeasure").each(function () {
      if(cminchBoolean) {
        $(this).attr("placeholder",window.operacampithemeStrings.measureInInches)
      } else {
        $(this).attr("placeholder",window.operacampithemeStrings.measureInCM)
      }
    })
  } else {
    $(".sizeFinder_lenMeasure").each(function () {
      if(cminchBoolean) {
        if($(this).hasClass("sizeFinder_sizingMeasure")) {
          $(this).attr("placeholder",window.operacampithemeStrings.measureInInches);
        }
        if(validateNumber($(this).val() == 0)) {} else {
          var value = convertCmToInch($(this).val());
          $(this).val(value);
        }
      } else {
        if($(this).hasClass("sizeFinder_sizingMeasure")) {
          $(this).attr("placeholder",window.operacampithemeStrings.measureInCM);
        }
        if(validateNumber($(this).val() == 0)) {} else {
          var value = convertInchToCm($(this).val());
          $(this).val(value);
        }
      }
    })
  }

}
$('input[type=radio][name="cminch"]').change(function() {
  //Change variables
  if(parseInt($("input[name='cminch']:checked").val()) == 0) {
    var cminchBooleanVerify = false;
  } else {
    var cminchBooleanVerify = true;
  }

  //Se non è cambiato esco
  if (cminchBooleanVerify != cminchBoolean) {cminchBoolean = cminchBooleanVerify;resetCmInch();} else {return false;}


  //Update measures
  measuresSizeUpdate();
});

function AIabundancy() {
  var weight = parseFloat($("#user_weight").val());
  var height = parseFloat($("#user_height").val());
  //Se siamo negli inches converto in cm per il calcolo
  if (cminchBoolean) {
    height = convertInchToCm(height);
  }

  var user_ratio = weight / height;
  if (typeof AImultiplicator !== 'undefined') {
    var abundancy = (user_ratio / 5.1)  + AImultiplicator;
  } else {
    var abundancy = user_ratio / 5.1;
  }
  return abundancy;

}
